import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { LINEUP_SLOTS } from "../../constants/fanPage";
import { colors } from "../../theme";
import {
  FIELD_SLOT_POSITIONS,
  infieldDiamondPoints,
  slotPositionSx,
} from "../../utils/fanPageField";
import LineupSlot from "./LineupSlot";

const SLOT_BY_ID = Object.fromEntries(LINEUP_SLOTS.map((slot) => [slot.id, slot]));

const FieldMarkings = () => {
  const mound = FIELD_SLOT_POSITIONS.P;

  return (
    <Box
      component="svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
      }}
    >
      <path
        d="M 10,32 Q 50,4 90,32"
        fill="none"
        stroke="rgba(255,255,255,0.08)"
        strokeWidth="0.4"
      />
      <polygon
        points={infieldDiamondPoints()}
        fill="rgba(255,255,255,0.035)"
        stroke="rgba(255,255,255,0.16)"
        strokeWidth="0.45"
        strokeLinejoin="round"
      />
      <circle
        cx={mound.x}
        cy={mound.y}
        r="3.4"
        fill="none"
        stroke="rgba(255,255,255,0.12)"
        strokeWidth="0.4"
      />
    </Box>
  );
};

const LineupField = ({ lineup, editable, onSelect, onClear, compact = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const renderSlot = (slotId, size) => (
    <Box key={slotId} sx={slotPositionSx(slotId)}>
      <LineupSlot
        slot={SLOT_BY_ID[slotId]}
        player={lineup?.[slotId]}
        editable={editable}
        size={size}
        pinToHeadshot
        onSelect={onSelect}
        onClear={onClear}
      />
    </Box>
  );

  if (isMobile || compact) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 2,
          py: 2,
        }}
      >
        {LINEUP_SLOTS.map((slot) => (
          <Box key={slot.id} sx={{ display: "flex", justifyContent: "center" }}>
            <LineupSlot
              slot={slot}
              player={lineup?.[slot.id]}
              editable={editable}
              size="battery"
              onSelect={onSelect}
              onClear={onClear}
            />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: 3,
        border: `1px solid ${colors.border}`,
        bgcolor: "#10140f",
        px: { md: 1.5 },
        py: 2,
      }}
    >
      <Box sx={{ px: { md: 1 }, py: { md: 2.5 } }}>
        <Box
          sx={{
            position: "relative",
            aspectRatio: "1",
            width: "100%",
            maxWidth: 560,
            mx: "auto",
            overflow: "visible",
          }}
        >
          <FieldMarkings />
          {renderSlot("LF", "field")}
          {renderSlot("CF", "field")}
          {renderSlot("RF", "field")}
          {renderSlot("SS", "field")}
          {renderSlot("2B", "field")}
          {renderSlot("3B", "field")}
          {renderSlot("1B", "field")}
          {renderSlot("P", "field")}
          {renderSlot("C", "field")}
          {renderSlot("DH", "field")}
        </Box>
      </Box>
    </Box>
  );
};

export default LineupField;
